import DashboardLayout from '../components/DashboardLayout';
import Breadcrumb from '../components/partials/Breadcrumb';
import PriceCard from '../components/partials/PriceCard';
import { checkoutUrl } from '../constants/externalLinks';

const comparisonRows: [string, React.ReactNode, React.ReactNode][] = [
  [
    'Probate Avoidance',
    <span className="dash-cmp-yes">✓</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
  [
    'Wyoming Privacy Laws',
    <span className="dash-cmp-yes">✓</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
  [
    'Dynasty Planning (up to 1,000 yrs)',
    <span className="dash-cmp-yes">✓</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
  [
    'Creditor / Lawsuit Protection',
    <span className="dash-cmp-lim">Limited</span>,
    <span className="dash-cmp-yes">✓ DAPT</span>,
  ],
  [
    'Estate Tax Mitigation (IDGT)',
    <span className="dash-cmp-no">—</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
  [
    'Offshore Backup (Cook Islands)',
    <span className="dash-cmp-no">—</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
  [
    'Trust Protector Role',
    <span className="dash-cmp-no">—</span>,
    <span className="dash-cmp-yes">✓</span>,
  ],
];

export default function EstatePlansPage() {
  return (
    <DashboardLayout>
      <div
        className="pl-14 pr-4 py-5 md:px-10 md:py-8"
        style={{ maxWidth: 960 }}
      >
        <Breadcrumb current="Enhanced Estate Plan & Trust" />

        {/* Hero */}
        <div className="dash-svc-hero">
          <div className="dash-svc-hero__inner">
            <p className="dash-svc-eyebrow">Enhanced Estate Plan & Trust</p>
            <h1 className="dash-svc-title font-serif">
              When paperwork isn't enough
            </h1>
            <div className="dash-svc-lede">
              <p>
                A basic living trust package gets the paperwork done. But if you
                have significant assets, real estate in multiple states, a
                crypto portfolio, a business, or a net worth approaching eight
                figures, paperwork isn't enough.
              </p>
              <p>
                The DAG Legacy Trust and the DAG Strategic Irrevocable Trust are
                built for people who need more than probate avoidance. They're
                built for privacy, generational wealth transfer, and the kind of
                creditor protection that holds up when it's tested.
              </p>
              <p>
                Both are attorney-drafted in Wyoming, the most favorable trust
                jurisdiction in the United States.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <p className="dash-svc-section-label">
          Which structure is right for you?
        </p>
        <div className="dash-price-grid">
          <PriceCard
            badge="The Foundation"
            name="DAG Legacy Revocable Living Trust"
            sub="Attorney-drafted. Wyoming jurisdiction."
            amount="$5,000"
            terms="One-time fee · Includes state-specific ancillary documents"
            features={[
              'Probate Avoidance',
              'Wyoming Privacy Laws',
              'Dynasty Planning (up to 1,000 years)',
              'Incapacity Protection',
              'Tax-Neutral Wyoming Administration',
            ]}
            mutedFeatures={['Creditor / Lawsuit Protection (Limited)']}
            bestFor="Families, privacy seekers, and multi-state property owners."
            checkoutHref={checkoutUrl('revocable-living-trust')}
            ctaLabel="Get Started · $5,000"
            featured
            ctaGold
          />
          <PriceCard
            badge="The Fortress"
            name="DAG Strategic Irrevocable Trust"
            sub="Dual-jurisdiction. Wyoming & Cook Islands."
            amount="$20,000"
            terms="$20,000 total · or $5,000/mo × 4 months"
            features={[
              'Everything in the Legacy Trust',
              'Creditor / Lawsuit Protection (DAPT)',
              'Estate Tax Mitigation (IDGT)',
              'Offshore Backup (Cook Islands)',
              'Trust Protector Role',
              'Event of Duress Clause',
            ]}
            bestFor="HNW individuals, high-risk professionals, and global investors."
            featured
            checkoutHref={checkoutUrl('irrevocable-trust-full')}
            ctaLabel="Pay in full · $20,000"
            ctaGold
            secondaryCta={{
              href: checkoutUrl('irrevocable-trust-plan'),
              label: 'Payment plan · $5,000/mo',
            }}
          />
        </div>

        {/* Comparison table */}
        <p className="dash-svc-section-label">Feature comparison</p>
        <div className="overflow-x-auto">
          <table className="dash-cmp-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Legacy RLT</th>
                <th>Strategic Irrevocable</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map(([feature, legacy, strategic]) => (
                <tr key={feature}>
                  <td>{feature}</td>
                  <td>{legacy}</td>
                  <td>{strategic}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
